/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {useEffect} from "react";

export const useDidMount = (callback) => {
    useEffect(() => {
        callback?.();

    }, []);
};
